import { common } from '../common';
import { colors } from './audi-colors';
export const audiDarkTheme = {
    ...common,
    name: 'Audi Dark Theme',
    colors,
};
//# sourceMappingURL=audi-dark.theme.js.map